import { http, createConfig, createStorage } from '@wagmi/core'
import { metaMask } from '@wagmi/connectors'
import { environment } from '../../../environments/environment'



const chains = [
  environment.SUPPORTED_CHAINS[0],
];

export const wagmiConfig = createConfig({
  chains: chains as any,
  connectors: [metaMask()], 
  storage: createStorage({ storage: window.localStorage }), 
  transports: {   
    [environment.CHAIN_ID]: http(),
  },
})